<template>
  <div v-if="useBpmAdditionalAgreement">
    <AddStageAdditionalAgreement
      v-if="$can('set', 'useCommonAgreements')"
      :mode="mode"
      :status-id="tender.tenderStatus ? tender.tenderStatus.id : null"
      :tender-id="tender.tenderId"
      :with-loading="withLoading"
      @updateAgreements="$emit('updateAgreements')"/>
    <AddAdditionalAgreement
      v-else
      :mode="mode"
      :tender="tender"
      :with-loading="withLoading"
      @updateAgreements="$emit('updateAgreements')"/>
  </div>
</template>
<script>
import AddAdditionalAgreement from 'components/agreement/AddAdditionalAgreement.vue'
import AddStageAdditionalAgreement from 'components/agreement/AddStageAdditionalAgreement.vue'

import { tenderMixin } from 'mixins'

export default {
  name: 'DialogAdditionalAgreement',
  mixins: [tenderMixin],
  components: {
    AddAdditionalAgreement,
    AddStageAdditionalAgreement
  },
  props: {
    tender: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: 'add',
      validator: function (value) {
        const correct = ['add', 'edit'].indexOf(value) !== -1
        return correct
      },
    },
    withLoading: {
      type: Boolean
    },
  },
  computed: {
    statusId() {
      return this.tender?.tenderStatus ? this.tender.tenderStatus.id : null
    },
    useBpmAdditionalAgreement() {
      let blockIfNewLogic = true
      if (this.$can('set', 'useCommonAgreements')) {
        /** для новой логики доступ к меню согласовантов только
         * при доступе к редактированию
         * или режим админа
         * или админ организации
         */
        blockIfNewLogic = this.$_checkCanEdit(this.tender, this.$_agreements) || this.$acl.check('isGoodMode') || this.$acl.check('tenderAdmin')
      }
      const statusId = this.statusId
      return blockIfNewLogic &&
        this.forceBpmAdditionalAgreementTenderStatuses?.length &&
        this.forceBpmAdditionalAgreementTenderStatuses.includes(statusId)
    },
    forceBpmAdditionalAgreementTenderStatuses() {
      return this.$store.getters['getSettings']?.tenderSettings?.forceBpmAdditionalAgreementTenderStatuses
    },
  }
}
</script>
